// AdminSettingsDashboard.jsx
import React, {useEffect, useState} from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Avatar,
  Typography,
  Divider,
  Grid2,
  Chip,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
  Paper,
  Button,
  ListItemAvatar
} from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import { DateTime } from "luxon";

import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import TokenRoundedIcon from '@mui/icons-material/TokenRounded';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import API from '../api/api';
import PlanSelector from '../Components/Card/PlanSelector';
import OrganizationFeaturesPanel from '../Components/Panels/OrganizationFeaturePanel';
import { AddToDrive, CheckCircle, Circle, Google, TuneRounded } from '@mui/icons-material';
import { AWS_LINK, DEV_LINK } from '../Static/static';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import IntegrationsList from '../Components/Lists/IntegrationsList';


// ---------------------------------------------------------------------------
// COMPONENT
// ---------------------------------------------------------------------------
export default function AdminSettingsDashboard() {
  const role = useSelector((state) => state.role); 
  const dispatch = useDispatch();
  const [org, setOrganization] = useState(null);
  
 

  const get_organizaion = async () => {
    try {
      const response = await API.get('/get_organization');
      if (response.data.organization) {
        setOrganization(response.data.organization);
      }
    }
    catch(error) {
      console.log(error)
      if (error.isAuthError || error.isForbidden) {
          return;
        } 
        if (error.isNetworkError) {
          dispatch(setSnackError({ 
            title: 'Connection Error', 
            body: error.message 
          }));
        } else {
          dispatch(setSnackError({
            title: 'Error found',
            body: error.message || 'Unable to add admin.'
          }));
        }
      return;
    }
  }

  const [materialUsage, setMaterialUsage] = useState(null);
  const [questionUsage, setQuestionUsage] = useState(null);
  const [availableIntegrations, setAvailableIntegrations] = useState(null);

  const get_integrations_available = async () => {
    try {
      const response = await API.get("/get_available_integrations")
      if (response.data) {
        setAvailableIntegrations(response.data);
      }
    }
    catch(error) {
      console.log(error)
      if (error.isAuthError || error.isForbidden) {
          return;
        } 
        if (error.isNetworkError) {
          dispatch(setSnackError({ 
            title: 'Connection Error', 
            body: error.message 
          }));
        } else {
          dispatch(setSnackError({
            title: 'Error found',
            body: error.message || 'Unable to get drive status.'
          }));
        }
      return;
    }
  }

  const get_llm_usage = async () => {
    try {
      const currentMonth = DateTime.local().month
      const currentYear = DateTime.local().year
      const response = await API.get('/get_generation_usage');
      if (response.data) {
        const materials = response.data.materials_usage;
        const questions = response.data.questions_usage;
        if (materials === null) {
          setMaterialUsage({input_tokens: 0, output_tokens: 0, totals: 0});
        } else {
          let materials_select = materials.find((item) => {
            let deli = item.year_month.split(":")
            let year = deli[0]
            let month = deli[1]
            if (currentMonth === Number(month) && currentYear === Number(year)){ return item;}});
            if (materials_select === undefined || materials_select === null){
              setMaterialUsage({input_tokens: 0, output_tokens: 0, totals: 0});
              return;
            } 
            setMaterialUsage({input_tokens: materials_select.input_sum, output_tokens: materials_select.output_sum, totals: (materials_select.output_sum + materials_select.input_sum)});
        }

        if (questions === null) {
          setQuestionUsage({input_tokens: 0, output_tokens: 0, totals: 0});
        } else {
          let questions_select = questions.find((item) => {
            let deli = item.year_month.split(":")
            let year = deli[0]
            let month = deli[1]
            if (currentMonth === Number(month) && currentYear === Number(year)){ return item;}});
            if (questions_select === null || questions_select === undefined){
            setQuestionUsage({input_tokens: 0, output_tokens: 0, totals: 0});
            return;
          } 
          setQuestionUsage({input_tokens: questions_select.input_sum, output_tokens: questions_select.output_sum, totals: (questions_select.output_sum + questions_select.input_sum)}); 
        }       
      }
    }
    catch(error) {
      console.log(error)
      if (error.isAuthError || error.isForbidden) {
          return;
        } 
        if (error.isNetworkError) {
          dispatch(setSnackError({ 
            title: 'Connection Error', 
            body: error.message 
          }));
        } else {
          dispatch(setSnackError({
            title: 'Error found',
            body: error.message || 'Unable to add admin.'
          }));
        }
      return;
    }
  }

  useEffect(() => {
    get_organizaion();
    get_llm_usage();

    get_integrations_available();
  }, [])

  async function openTab(url) {
    console.log(url)
    window.open(url, '_blank').focus();
  }


  const handleGoogleSync = () => {
    const width = 500;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    const LINK = process.env.NODE_ENV === "production" ? AWS_LINK : DEV_LINK;
    const stored_role = localStorage.getItem('role');
    if (!stored_role) return;
  
    const { token } = JSON.parse(stored_role);
  
    const popup = window.open(
      `${LINK}/handle_google_auth?token=${token}`,
      "Connect Google Drive",
      `width=${width},height=${height},left=${left},top=${top}`
    );
  
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== "GOOGLE_AUTH") return;
  
      const { status } = event.data;
      if (status === "connected") {
        dispatch(setSuccessSnack({ title: "Success", body: "Google Drive connected" }));
      } else {
        dispatch(setSnackError({ title: "Error", body: "Google Drive connection failed" }));
      }
  
      clearInterval(pollClosed);                          
      window.removeEventListener("message", handleMessage);
      if (popup && !popup.closed) popup.close();
    };
  
    window.addEventListener("message", handleMessage);   
  
    const pollClosed = setInterval(() => {
      if (popup?.closed) {
        clearInterval(pollClosed);
        window.removeEventListener("message", handleMessage);
      }
    }, 500); 
  };

  const handle7ShiftSync = async (row, credential) => {
    try {
      const body = {integration_id: row.id, ...credential}
      console.log(body);
      let response = await API.post('/upsert_credentials_7shift', body );
      const data = response.data.data;
      if (data.status === 'OK') {
        openTab(data.url);
        dispatch(setSuccessSnack({title: "Success", body: "Integration completed."}));
      }
    }
    catch(error) {
      if (error?.status === 401) {
        dispatch(setSnackError({title: 'Error', body: error.message || 'Signing out..'}))
        return;
      }
      dispatch(setSnackError({title: 'Error', body: error.message}));
      return;
    } 
  };

  const handlePlanChange = async (values, stripe_customer_id) => {
    try {
      if (!values.price_id) { return ;}
      if (values.id === 1) {}
      let response = await API.post('/create_checkout_session', {price_id: values.price_id, customer_id: stripe_customer_id});
      const data = response.data.data;
      if (data.status === 'OK') {
        openTab(data.url);
      }
    }
    catch(error) {
      if (error?.status === 401) {
        dispatch(setSnackError({title: 'Error', body: error.message || 'Signing out..'}))
        return;
      }
      dispatch(setSnackError({title: 'Error', body: error.message}));
      return;
    } 
  } 

  const handleSession = async (stripe_customer_id) => {
    try {
      if (!stripe_customer_id) { return ;}
      let response = await API.post('/create_portal_session', {customer_id: stripe_customer_id});
      const data = response.data.data;
      if (data.status === 'OK') {
        openTab(data.url);
      }
    }
    catch(error) {
      if (error?.status === 401) {
        dispatch(setSnackError({title: 'Error', body: error.message || 'Signing out..'}))
        return;
      }
      dispatch(setSnackError({title: 'Error', body: error.message}));
      return;
    } 
  } 


  const handleIntegrationClick = (row, credentials) => {
    var integration = row.provider;
    switch (integration) {
      case "7Shifts":
        handle7ShiftSync(row, credentials);
        break
      case "Google drive":
        handleGoogleSync();
        break;
    }
  }

  return (
    <Box sx={{  mx: 'auto' }}>
      {/* Left aligned layout: remove center justification; use Grid2 to create sections */}
      <Grid2 container spacing={3}>
        {/* SECTION 1: User + Organization */}
        <Grid2 item size={{xs:12, md:5}}>
          <Card sx={{ borderRadius: 0 }}>
            <CardHeader
              title="User"
              subheader="Profile details"
              avatar={
                <Avatar sx={{ bgcolor: 'secondary.main' }}>
                  {role.first_name?.[0] || 'U'}
                </Avatar>
              }
            />
            <Divider />
            <CardContent>
              <Stack spacing={1.25}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <BadgeRoundedIcon color="inherit" />
                  <Typography variant="body1" fontWeight={600}>
                    {role.first_name} 
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <BadgeRoundedIcon color="inherit" />
                  <Typography variant="body1" fontWeight={600}>
                    {role.role} 
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <EmailRoundedIcon color="inherit" />
                  <Typography variant="body2" color="text.secondary">
                    {role.email}
                  </Typography>
                </Stack>
                
              </Stack>
            </CardContent>
          </Card>

          <Box sx={{ height: 16 }} />

          <Card sx={{ borderRadius: 0 }}>
            <CardHeader
              title="Business / Organization"
              subheader="Registered details"
              avatar={<FolderCopyRoundedIcon color="secondary" />}
            />
            <Divider />
            <CardContent>
              <List dense disablePadding>
                <ListItem>
                  <ListItemIcon>
                    <BusinessRoundedIcon color="inherit" />
                  </ListItemIcon>
                  <ListItemText
                    primary={org && org.title}
                    secondary="Organization Name"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <PlaceRoundedIcon color="action" />
                  </ListItemIcon>
                  <ListItemText
                    primary={org && `${org.address}, ${org.city}, ${org.state} ${org.zip_code}`}
                    secondary="Address"
                  />
                </ListItem>
                
              </List>
            </CardContent>
          </Card>
          <Box sx={{ height: 16 }} />
          <Card>
            <IntegrationsList 
              onEnable={(e, credentials) => handleIntegrationClick(e, credentials)} 
              integrations={availableIntegrations} 
              onManage={(e) => handleIntegrationClick(e)} />
          </Card>
        </Grid2>

        {/* SECTION 2: LLM Generation Totals */}
        <Grid2 item size={{xs:12, md:7}}>
          <Card sx={{ borderRadius: 0 }}>
            <CardHeader
              title="LLM Usage & Generation"
              subheader={
                <Stack>
                  <Typography variant='body2'>
                    Aggregated totals across materials & questions
                  </Typography>
                  <Typography variant='body2'>
                    Current limits: 1 Million tokens per month
                  </Typography>
                </Stack>
              }
              avatar={<QueryStatsRoundedIcon color="secondary" />}
            />
            <Divider />
            <CardContent>
              {/* Totals Overview */}
              <Grid2 container spacing={2}>
                <Grid2 item size={{xs: 12, md:6 }}>
                  <Paper variant="outlined" sx={{ p: 2, borderRadius: 0 }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Materials LLM generation
                    </Typography>
                    <Stack spacing={1.5} sx={{ mt: 1 }}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <TokenRoundedIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          Input tokens: <strong>{materialUsage && materialUsage.input_tokens}</strong>
                        </Typography>
                      </Stack>
                      <LinearProgress
                        color="inherit"
                        variant="determinate"
                        value={
                          materialUsage && ((Math.max(1, materialUsage.input_tokens)) / 1000000) * 100
                        }
                        sx={{ height: 6, borderRadius: 999 }}
                      />
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <TokenRoundedIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          Output tokens: <strong>{materialUsage && materialUsage.output_tokens}</strong>
                        </Typography>
                      </Stack>
                      <LinearProgress
                        color="secondary"
                        variant="determinate"
                        value={
                          materialUsage && ( (Math.max(1, materialUsage.output_tokens)) / 1000000) * 100
                        }
                        sx={{ height: 6, borderRadius: 999 }}
                      />
                    </Stack>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                      {DateTime.local().monthLong + "-" + DateTime.local().year}
                    </Typography>
                  </Paper>
                </Grid2>
                <Grid2 item size={{xs: 12, md:6 }}>
                  <Paper variant="outlined" sx={{ p: 2, borderRadius: 0 }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Questions LLM generation
                    </Typography>
                    <Stack spacing={1.5} sx={{ mt: 1 }}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <TokenRoundedIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          Input tokens: <strong>{questionUsage && questionUsage.input_tokens}</strong>
                        </Typography>
                      </Stack>
                      <LinearProgress
                        color="inherit"
                        variant="determinate"
                        value={
                          questionUsage && ((Math.max(1, questionUsage.input_tokens))/ 1000000) * 100
                        }
                        sx={{ height: 6, borderRadius: 999 }}
                      />
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <TokenRoundedIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          Output tokens: <strong>{questionUsage && questionUsage.output_tokens}</strong>
                        </Typography>
                      </Stack>
                      <LinearProgress
                        color="secondary"
                        variant="determinate"
                        value={
                          questionUsage && ( (Math.max(1, questionUsage.output_tokens)) / 1000000 ) * 100
                        }
                        sx={{ height: 6, borderRadius: 999 }}
                      />
                    </Stack>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                      { DateTime.local().monthLong + "-" + DateTime.local().year}
                    </Typography>
                  </Paper>
                </Grid2>                
              </Grid2> 
            </CardContent>
          </Card>
          <Card>
              <OrganizationFeaturesPanel />
          </Card>
          
        </Grid2>

        <Grid2 item size={{xs:12, md:12}}>
          <Box>
            {role && role.role === "ROOT" && 
            <PlanSelector onSelectClick={(e, u) => handlePlanChange(e, u)}  onChange={(e) => console.log(e)} onManageSubsription={(e) => handleSession(e)} />}
          </Box>
        </Grid2>

        
      </Grid2>
    </Box>
  );
}